{
    "users": {
        "title": "Users del tenant",
        "create": "Crear user",
        "table": {
            "name": "Nombre",
            "email": "Email",
            "status": "Estado",
            "roles": "Roles",
            "actions": "Acciones"
        },
        "form": {
            "email": "Email",
            "displayName": "Nombre",
            "role": "Rol",
            "scope": "Scope",
            "scopeRef": "Referencia del scope"
        }
    },
    "retailers": {
        "actions": {
            "delete": "Eliminar"
        },
        "delete": {
            "title": "Eliminar retailer",
            "description": "¿Eliminar el retailer «{{name}}»? Esta acción no se puede deshacer.",
            "confirm": "Eliminar",
            "success": "Retailer eliminado",
            "error": "No se pudo eliminar el retailer"
        }
    },
    "roles": {
        "title": "Roles del tenant",
        "system": "Sistema",
        "custom": "Personalizado",
        "create": "Crear role custom"
    },
    "branding": {
        "title": "Branding del tenant",
        "primaryColor": "Color primario",
        "secondaryColor": "Color secundario",
        "accentColor": "Color de acento",
        "logoUrl": "URL del logo"
    },
    "audit": {
        "title": "Audit del tenant"
    },
    "externalIds": {
        "title": "Niveles con identificador propio",
        "hint": "Cuando un nivel está marcado, esta organización trae su propio identificador para ese nivel (el de su sistema) en lugar de uno generado por la plataforma. Si no marcas ninguno, la plataforma genera los identificadores."
    }
}
